import { useCallback } from 'react';
import axiosInstance from '../../../axiosInstance';

/**
 * useFieldWavesApi Hook
 *
 * Pure API hook for field waves (change history) operations.
 *
 * @returns {Object} - { getFieldWaves }
 */
const useFieldWavesApi = () => {
  /**
   * Fetches field waves (change history) for a specific field in a request.
   *
   * @param {number|string} requestId - The request ID
   * @param {string} fieldId - The field ID in format formId_subformId_fieldId
   * @returns {Promise<{data: Array, count: number}>}
   */
  const getFieldWaves = useCallback(async (requestId, fieldId) => {
    const response = await axiosInstance.get(
      `/api/field-waves/${requestId}/${encodeURIComponent(fieldId)}`
    );
    return response.data;
  }, []);

  /**
   * Fetches distinct field IDs that have wave data for a request.
   *
   * @param {number|string} requestId - The request ID
   * @returns {Promise<string[]>} Array of field IDs that have waves
   */
  const getFieldsWithWaves = useCallback(async (requestId) => {
    const response = await axiosInstance.get(
      `/api/field-waves/${requestId}/fields-with-waves`
    );
    return response.data.fieldIds || [];
  }, []);

  return { getFieldWaves, getFieldsWithWaves };
};

export default useFieldWavesApi;
